/**
* lookups for licence field values
*/

/**
 * convert GW/SW abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} type uppercase abbreviation from the database
 * @return {String}      expanded string for display
 */
export function licenceType(type) {
    if (type === 'SW') {
        return 'Surface Water';
    } else if (type === 'GW') {
        return 'Groundwater';
    }
    return type;
}

/**
 * convert long/short abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} term lowercase abbreviation from the database
 * @return {String}      expanded string for display
 */
export function licenceTermLength(term) {
    if (term === 'long') {
        return 'Long-term';
    } else if (term === 'short') {
        return 'Short-term';
    }
    return term;
}

/**
 * convert long/short abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} term lowercase abbreviation from the database
 * @return {String}      expanded string for display
 */
export function licenceTermType(term) {
    if (term === 'long') {
        return 'Water Licence';
    } else if (term === 'short') {
        return 'Use Approval';
    }
    return term;
}

/**
 * format branding organization for display
 * shortens input to an acronym
 * @param  {String} org full branding organization value from the database
 * @return {String}     abbreviated value for display
 */
export function brandingOrganization(org) {
    let display = org;
    if (typeof org === 'string') {
        display = org.replace(/[^A-Z]/g, '');
    }

    return display;
}



// WEBPACK FOOTER //
// ./src/functions/licenceFieldTranslate.js